export default "__VITE_ASSET__B2wp7HWF__"